import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import { JOB_TITLE_PATHNAME } from '@glass/common/modules/pages/paths';
import { BASE_PATH_1_QUERY, BASE_PATH_3_QUERY } from '@glass/common/modules/pages/queryParams';

import Link from '@glass/shared/components/Link/Link';
import useBrowseBasePath from '@glass/shared/components/Link/useBrowseBasePath';
import getJobTitleLinkParams from '@glass/shared/modules/jobTitles/getJobTitleLinkParams';
import industryPropTypes from '@glass/shared/modules/jobTitles/industryPropTypes';

const JobTitleLink = React.forwardRef(
  (
    {
      [BASE_PATH_1_QUERY]: basePath1Prop,
      jobTitleSlug,
      industries,
      template,
      children,
      className,
      onClick,
      prefetch,
      industrySlug,
      ...otherProps
    },
    ref,
  ) => {
    const basePath1 = useBrowseBasePath(basePath1Prop);
    const href = useMemo(
      () => ({
        pathname: JOB_TITLE_PATHNAME,
        query: getJobTitleLinkParams({
          template,
          [BASE_PATH_1_QUERY]: basePath1,
          [BASE_PATH_3_QUERY]: jobTitleSlug,
          industries,
        }),
      }),
      [template, basePath1, jobTitleSlug, industries],
    );

    if (__DEV__) {
      const keys = Object.keys(otherProps);
      if (keys.length) {
        console.warn(
          `WARNING - REMOVE PROP SPREADING - link prop spreading with extra keys: ${keys.join()}`,
        );
      }
    }

    return (
      <Link
        {...otherProps}
        ref={ref}
        className={className}
        href={href}
        industrySlug={industrySlug}
        prefetch={prefetch}
        onClick={onClick}
      >
        {children}
      </Link>
    );
  },
);

JobTitleLink.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  industries: PropTypes.arrayOf(PropTypes.shape(industryPropTypes)),
  jobTitleSlug: PropTypes.string,
  onClick: PropTypes.func,
  prefetch: PropTypes.bool,
  resume: PropTypes.string,
  section: PropTypes.string,
  seed: PropTypes.string,
  template: PropTypes.string,
  title: PropTypes.string,
};

JobTitleLink.displayName = 'JobTitleLink';

export default React.memo(JobTitleLink);
